import { api } from '@/global/services/api'
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'

const MAXIMUM_DISPLAY_MARKERS = 10000
export default {
  name: 'IndexTableMapHelper',

  data () {
    return {
      markersMap: new Map(),
      markers: [],
      markerCluster: null,
      initialRender: false,
      map: null,
      googleMaps: null,
      AdvancedMarker: null,
      allMarkersData: [],
      visibleMarkers: [],
      canUpdateMarkers: false
    }
  },

  methods: {
    // On map initialization (map and googleMaps objects are populated) show markers grouped inside the marker cluster
    async mapInitialized (event) {
      try {
        const { map, googleMaps, advancedMarker: AdvancedMarker } = event?.event || {}
        if (!map || !googleMaps) return

        this.map = map
        this.googleMaps = googleMaps
        this.markersMap = new Map()
        this.allMarkersData = []
        this.visibleMarkers = []
        this.AdvancedMarker = AdvancedMarker

        // Fetch all markers only once
        const { data } = await api('road-maintenance').get('traffic-regulation/icons')
        this.allMarkersData = data || []

        // map.addListener('idle', () => {
        //   this.updateVisibleMarkers()
        // })

        this.initialRender = true
        this.updateVisibleMarkers()
      }
      catch (error) {
        console.error(error)
      }
    },

    updateVisibleMarkers () {
      const bounds = this.map.getBounds()
      const boundsForShow = new this.googleMaps.LatLngBounds()
      if (!bounds) return

      const mapZoom = this.map.getZoom()
      // Clear existing markers
      this.visibleMarkers.forEach(marker => marker.setMap(null))
      this.visibleMarkers = []

      const markersInBounds = []

      for (const data of this.allMarkersData) {
        const position = new this.googleMaps.LatLng(data.lat, data.lon)
        const marker = new this.AdvancedMarker({
          position
        })
        marker.id = data.id
        if (bounds.contains(position)) {
          markersInBounds.push({ data, position, marker })
        }
      }

      // Limit to 100 markers
      this.visibleMarkers = markersInBounds.slice(0, MAXIMUM_DISPLAY_MARKERS).map(({ data, position, marker }) => {
        marker.setMap()
        this.markersMap.set(data.id, marker)
        if (this.initialRender) {
          boundsForShow.extend(position)
        }
        return marker
      })

      // Re-create a cluster with the limited markers
      if (this.markerCluster) {
        this.markerCluster.clearMarkers()
      }

      this.markerCluster = new MarkerClusterer({
        markers: this.visibleMarkers,
        map: this.map,
        algorithm: new SuperClusterAlgorithm({
          radius: mapZoom >= 14 ? 60 : mapZoom > 10 ? 100 : 150,
          maxZoom: 18
        })
      })

      if (this.initialRender) {
        this.map.fitBounds(boundsForShow)
        this.initialRender = false
      }
    }
  }
}
